module.exports = __webpack_public_path__ + "avatar8.svg?b865e7fe27f1247570a0f63a7c995bcf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar8.svg
// module id = 144
// module chunks = 2